import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { TechnologyoverlayService } from '../../../technologyoverlay.service';
import { takeUntil } from 'rxjs/operators';
import { SessionCheck, generateAlertMessage,AuthFailedMessage } from '../../../../../app-general';
import {Router} from '@angular/router';
import { ApiService } from '../../../../../api.service';
import { ZoneByID, getTemplates, addTemplateZone } from '../../../technologyoverlay';
import { getCampus, getBuilding } from '../../../../../api';
import { appsettings } from '../../../../../app-settings';

@Component({
  selector: 'app-add-template',
  templateUrl: './add-template.component.html',
  styleUrls: ['./add-template.component.scss']
})
export class AddTemplateComponent implements OnInit {

  public flooraddTempateForm : FormGroup;
  public floorTempateForm : FormGroup;
  selectedTempId;
  FloorInfo;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  SpaceInfo;
  watcher: Subscription;  
  firstcolumns = 2;  
  rowHeight = "79px";
  checkfloorinfo = false;  
  Templatedetails;
  Tempflag = 0;
  Campusdetails;
  Buildingdetails;
  selectedCampusId;
  selectBuildId;
  selTemp_Id;
  
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<AddTemplateComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService, public dialog: MatDialog, private apiService: ApiService) { 
    
    if(data.Tempflag == 1)
    {
      this.Tempflag = 1;
      this.selTemp_Id = data.SelectTempId;
      this.selectedCampusId = data.CampusId;
      this.selectBuildId = data.BuildingId;
    }
    else
    {
      this.selectedCampusId = data.CampusId;
      this.selectBuildId = data.BuildId;
    }
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {          
          this.firstcolumns = 1;                            
        } 
        else if (change.mqAlias == 'sm') {          
          this.firstcolumns = 2;               
        }  
        else if (change.mqAlias == 'md') {          
          this.firstcolumns = 2; 
        }               
       else
       {         
         this.firstcolumns = 2;                           
       }
      }
    
    });
  }

  ngOnInit() {
    
    this.floorTempateForm = new FormGroup({
      template: new FormControl('',[Validators.required])     
    })    
    
    this.flooraddTempateForm = new FormGroup({
      campus: new FormControl('',[Validators.required]),     
      building: new FormControl('',[Validators.required]),  
      floorname: new FormControl('',[Validators.required, Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)])
    }) 
    
    if(this.Tempflag == 0)
      this.getTemplates();
      
    else if(this.Tempflag == 1)
      this.getCampusDetails();
  }
  
public onCloseCancel = () => 
{   
    try
    {
      this.thisDialogRef.close('Cancel');
      if(!SessionCheck(this.router))
      {
          return;
      }
      
    }
    catch(err)
    {
      throw new Error('edit-floor.component.ts' + ' - onCloseCancel() - ' + err.message);
    }

}  
  //Use Template will show the list of templates available. We can choose a template from drop down.
getTemplates()
{
  try
  {
    let tempdata: getTemplates = {
      siteId : this.SiteId,
      authKey: localStorage.getItem("Authkey"),      
    }
    let template_data = [];
    this.technologyoverlayService.getTemplates(tempdata).pipe(takeUntil(this._onDestroy))
    .subscribe((TempDetails : any[])=>{              
      TempDetails.forEach(function(e){   
      if(e.TemplateCategoryId == 1)
      {
        template_data.push(e);
      }
      })      
      this.Templatedetails = template_data;             
    });  
  }
  catch (err) {
    throw new Error('add-template.component.ts' + ' - getTemplates() - ' + err.message);
  }
}  


selecttemplatefloorDetails(floortempformvalue)
{
  try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      (document.activeElement as HTMLTextAreaElement).blur(); 
      if (this.floorTempateForm.valid) { 
        this.loadTemplatedetails(floortempformvalue)
      }
    }
    catch(err)
    {
      throw new Error('duplicate-floor.component.ts' + ' - duplicatefloorDetails() - ' + err.message);
    }
}

loadTemplatedetails(floortempformvalue)
{  
  let saveclick = document.getElementById('btnsavenextclick');
  saveclick.className = 'clstempsavebutton mat-raised-button disablebtn';
  this.Tempflag = 1;
  let tempdata = {Tempflag : this.Tempflag, SelectTempId: this.selectedTempId, CampusId: this.selectedCampusId, BuildingId: this.selectBuildId}
  
  this.thisDialogRef.close('Cancel');   
  let dialogRef = this.dialog.open(AddTemplateComponent, {
    disableClose: true,
    width: '32em',
    height:'400px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
    data:tempdata,
  });

  dialogRef.afterClosed().subscribe(result => {           
    if(result != "" && result != "Cancel")
    {
      this.getFloorDetailsbyId(result)
    }
  })
}

changeTemplate(tempid)
{
  this.selectedTempId = tempid;
}

getCampusDetails()
{
  try
    {
      let campusid: getCampus = {
        siteId : this.SiteId,
        authKey: localStorage.getItem("Authkey")
      }
      this.apiService.getCampusDetails(campusid).pipe(takeUntil(this._onDestroy))
      .subscribe((CampusDetails : any[])=>{  
        this.Campusdetails = CampusDetails["apiReturn"];
        this.getBuildingDetails(this.selectedCampusId)      
      });  
    }
    catch (err) {
      throw new Error('add-template.component.ts' + ' - getCampusDetails() - ' + err.message);
    }
} 

getBuildingDetails(campusid)
{
  try
    {
      let buildid: getBuilding = {
        siteId : this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        campusId:parseInt(campusid)
      }
      this.apiService.getBuildingDetails(buildid).pipe(takeUntil(this._onDestroy))
      .subscribe((BuildingDetails : any[])=>{  
        this.Buildingdetails = BuildingDetails["apiReturn"];       
      });  
    }
    catch (err) {
      throw new Error('add-template.component.ts' + ' - getBuildingDetails() - ' + err.message);
    }
} 

changecampus_Template(campusid)
{
  this.selectedCampusId = campusid;
  this.selectBuildId = 0;
  this.flooraddTempateForm.controls['building'].setValue('');
  this.getBuildingDetails(this.selectedCampusId)
}

changebuilding_Template(buildingid)
{
  this.selectBuildId = buildingid;
}

handleInput(event) 
{
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.flooraddTempateForm.controls).forEach(field => { // {1}
        const control = this.flooraddTempateForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('add-template.component.ts' + ' - handleInput() - ' + err.message);
    }
}

public addtemplatefloorDetails = (addfloortempformvalue) => 
  {

    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      (document.activeElement as HTMLTextAreaElement).blur(); 
      if (this.flooraddTempateForm.valid) { 
        this.addTemplateZone(addfloortempformvalue)
      }
    }
    catch(err)
    {
      throw new Error('duplicate-floor.component.ts' + ' - duplicatefloorDetails() - ' + err.message);
    }
  }
  //Add zone is used to add a new zone in the selected building. When will click the Add new zone it will show the popup window with the following option
  //2. Use Template
addTemplateZone(addfloortempform)
{
  try
  {
    let saveclick = document.getElementById('btnsavetemplateaddclick');
    saveclick.className = 'clstempsavebutton mat-raised-button disablebtn'; 
    
    let templatefloor: addTemplateZone = {
      siteId:this.SiteId,
      authKey:localStorage.getItem("Authkey"),
      templateId:parseInt(this.selTemp_Id),
      campusId:parseInt(addfloortempform.campus),
      buildingId:parseInt(addfloortempform.building),
      newZoneName:addfloortempform.floorname.toString(),
      newZoneDescription:addfloortempform.floorname.toString()
    }
    
    this.technologyoverlayService.addTemplateZone(templatefloor).pipe(takeUntil(this._onDestroy))
    .subscribe((apiresponse: any[]) => 
    {          
        
        if(apiresponse["FloorId"] > 0)
        {                    
          this.thisDialogRef.close(apiresponse["FloorId"]); 
        }
        else if(apiresponse.toString() == "false")
        {
          generateAlertMessage(this.dialog, 'Zone Template added failed.');       
          saveclick.className = 'clstempsavebutton mat-raised-button'; 
          this.thisDialogRef.close("close"); 
        }
        else if(apiresponse["condition"] == "Authfalse")
        {     
          this.thisDialogRef.close('Cancel');              
          AuthFailedMessage(this.dialog,this.router);  
          return;   
        } 
        else 
        {
          generateAlertMessage(this.dialog, "Zone name '" + apiresponse[0].FloorName + "' already exists.");              
          saveclick.className = 'clstempsavebutton mat-raised-button';
          return; 
        }
        
    })
  }
  catch(err)
  {
    throw new Error('add-template.component.ts' + ' - addTemplateZone() - ' + err.message);
  }
}

getFloorDetailsbyId(floorid)
{  
  let floorbyid: ZoneByID = {
    siteId: this.SiteId,
    authKey: localStorage.getItem("Authkey"),
    zoneId: parseInt(floorid)
}

this.technologyoverlayService.getZoneById(floorbyid).pipe(takeUntil(this._onDestroy))
  .subscribe((FloorByid : any[])=>{    
    
    this.router.navigate(['../../mapfloor'], { state: FloorByid["apiReturn"][0] });
  });
  
}

}
